'use client'
import React from 'react'
import styles from './styles.module.scss'
import Image from 'next/image'
import { useModalLink } from '@l2p/apps-shared'
import { POPUP_CONSTANTS } from '@l2p/apps-shared'
import Link from 'next/link'
import { useTranslations } from 'next-intl'

const AddBalance = () => {
  const t = useTranslations('translation')
  const addCurrencyHref = useModalLink(POPUP_CONSTANTS.ADD_CURRENCY)

  return (
    <Link href={addCurrencyHref}>
      <div className={styles.container}>
        <Image width={30} height={30} src="/img/icons/plus.svg" alt="add" />
        <div className={styles.text}>{t('addCurrency')}</div>
      </div>
    </Link>
  )
}

export default AddBalance
